import { render, staticRenderFns } from "./bnvpassword.vue?vue&type=template&id=645b522a&"
import script from "./bnvpassword.vue?vue&type=script&lang=js&"
export * from "./bnvpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports